module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 secondary secondary--text",
    attrs: {
      "slot": "activator",
      "outline": "",
      "large": ""
    },
    slot: "activator"
  }, [_vm._t("default", [_vm._v("Marcar como realizada")])], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Marcar tarefa como realizada?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("Para marcar uma tarefa como realizada você precisa preencher uma observação referente a tarefa.")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Observação",
      "multi-line": "",
      "name": "observacao",
      "data-vv-as": "observação",
      "error-messages": _vm.errors.has('observacao') ? _vm.errors.first('observacao') : []
    },
    model: {
      value: (_vm.form.fields.conteudo),
      callback: function($$v) {
        _vm.form.fields.conteudo = $$v
      },
      expression: "form.fields.conteudo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Ainda não")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8731a318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tarefas/TarefasRealizar.vue
// module id = 1034
// module chunks = 1